var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'construct-a-response'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('keyboard-adaptation-wrapper', {
    staticClass: "construct-a-response-wrapper",
    attrs: {
      "defaultHeight": 330
    }
  }, [_c('div', {
    staticClass: "activity-container"
  }, [_c('section', {
    staticClass: "question-section"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound && _vm.currentRound.questionHtml
    }
  })], 1), _c('text-editor', {
    ref: "textEditor",
    staticClass: "text-editor",
    attrs: {
      "maxLength": _vm.maxLength,
      "autoFocus": true,
      "keyboardAdaptationWrapperMinElementHeight": 100,
      "isMobile": _vm.isMobile
    },
    model: {
      value: _vm.answer,
      callback: function ($$v) {
        _vm.answer = $$v;
      },
      expression: "answer"
    }
  })], 1)]), _vm._t("keyboard")], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }